import { render, staticRenderFns } from "./normal.vue?vue&type=template&id=2a89f14e&scoped=true&"
import script from "./normal.vue?vue&type=script&lang=js&"
export * from "./normal.vue?vue&type=script&lang=js&"
import style0 from "./normal.vue?vue&type=style&index=0&id=2a89f14e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a89f14e",
  null
  
)

export default component.exports